module.exports = "fragment GridType on ComponentSharedGridArea {\n  __typename\n  colStart\n  colEnd\n  rowEnd\n  rowStart\n}\n"